// extracted by mini-css-extract-plugin
export default {"LinkBtn":"LinkBtn_LinkBtn__Y4RKL"};